var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('idf-toast',{ref:"toast",attrs:{"kind":_vm.notification.kind}},[_vm._v(_vm._s(_vm.notification.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }